export interface AdvancedFeature {
  iconUrl: string
  title: string
  description: string
  descriptionMobile?: string
}

export const advancedFeatures: AdvancedFeature[] = [
  {
    iconUrl: "https://a.bracky.app/assets/landing/icons/features-icon-global-fan-network.webp",
    title: "Global Fan Network",
    description: "Bracky takes bets in any language, building the first social sports betting network led by Fans",
    descriptionMobile: "Bracky responds in any language, building the first social sports betting network led by Fans",
  },
  {
    iconUrl: "https://a.bracky.app/assets/landing/icons/features-icon-live-betting-iq.webp",
    title: "Live Betting IQ",
    description: "Bracky tracks live games to always keep you on top of key moments and pivotal plays in real-time",
    descriptionMobile:
      "Bracky tracks live games to always keep you on top of key moments and pivotal plays in real-time",
  },
  {
    iconUrl: "https://a.bracky.app/assets/landing/icons/features-in-feed-notifications-12.webp",
    title: "In Feed Alerts",
    description: "Bracky alerts you to major events in sports as the drama unfolds, so you're always in the game",
    descriptionMobile: "Bracky alerts you to major events in sports as the drama unfolds, so you're always in the game",
  },
  {
    iconUrl: "https://a.bracky.app/assets/landing/icons/features-icon-automatic-market-making.webp",
    title: "Autonomous Market Making",
    description: "Bracky creates fresh betting markets and balances liquidity to ensure competitive odds",
    descriptionMobile: "Bracky creates fresh betting markets and balances liquidity to ensure competitive odds",
  },
  {
    iconUrl: "https://a.bracky.app/assets/landing/icons/features-icon-advanced-memory.webp",
    title: "AI Edge Insights",
    description: "Bracky learns your betting style and preferences to deliver personalized bracket insights",
    descriptionMobile: "Bracky learns your betting style and preferences to deliver personalized bracket insights",
  },
]
